import {APP_INITIALIZER, Injector, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {LOCATION_INITIALIZED} from '@angular/common';
import * as _ from 'lodash';
import {NavbarComponent} from './components/navbar/navbar.component';
import {MenubarModule} from 'primeng/menubar';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastModule} from 'primeng/toast';
import {TransitionPageModule} from './components/transition-page/transition-page.module';
import {MessageService} from 'primeng/api';
import {AuthGuard} from './guards/auth';
import {CookieService} from 'ngx-cookie-service';
import {AuthInterceptor} from './helpers/auth.interceptor';
import {FormModule} from './modules/form/form.module';
import {MenuModule} from 'primeng/menu';
import {JWT_OPTIONS, JwtHelperService} from '@auth0/angular-jwt';
import {ChangePasswordModalModule} from './components/modals/change-password-modal/change-password-modal.module';

// =====================================
// ======= translation functions =======
// =====================================
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function appInitializerFactory(translate: TranslateService, injector: Injector): object {
  return () => new Promise<any>((resolve: any) => {
    const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
    locationInitialized.then(() => {
      const navLang = navigator.language ? _.first(_.split(navigator.language, '-')) : null;
      const langToSet = navLang ? navLang : 'es';
      translate.setDefaultLang('es');
      translate.use(langToSet || 'es').subscribe({
        next: () => {
        },
        error: () => {
          console.error(`Problem with '${langToSet}' language initialization.'`);
        },
        complete: resolve(null)
      });
    });
  });
}

// =====================================

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MenubarModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToastModule,
    TransitionPageModule,
    FormModule,
    MenuModule,
    ChangePasswordModalModule
  ],
  exports: [
    TranslateModule
  ],
  providers: [
    AuthGuard,
    CookieService,
    MessageService,
    JwtHelperService,
    {provide: JWT_OPTIONS, useValue: JWT_OPTIONS},
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: APP_INITIALIZER, useFactory: appInitializerFactory, deps: [TranslateService, Injector], multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
